__turbopack_context__.v({
  "footer": "index-module-scss-module__hYw3Fa__footer",
  "main": "index-module-scss-module__hYw3Fa__main",
  "maintenance": "index-module-scss-module__hYw3Fa__maintenance",
});
